import { useState } from "react";
import { useLookupMessagesQuery } from "../../stores/OkOkStore";
import type { Messages } from "../../types/Messages";
import type { QueryParameters } from "../../types/QueryParameters";
import Pager from "../Common/Pager";
import { NavLink } from "react-router";
import { useTrads } from "../../contexts/trads/useTrads";
import parse from 'html-react-parser';

function MessagesList({dest_id,topic,version}:{dest_id:number,topic:string,version:number}){
    const [params,setParams]=useState<QueryParameters>(
            {
                page:0,
                r:{
                    dest_id:dest_id.toString(),
                    topic: topic
                }

            }
        );
    const { data, error, isLoading } = useLookupMessagesQuery(params);
    const {translate}=useTrads();

    const setPage=function(page:number){
        setParams({...params,page: page})
    }

        return (
 
            error ? (
                <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>
            ) : isLoading ? (
                <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p>
            ) : data ? (
                <>
                <table className="table" data-version={version}>
                <thead>
                    <tr>
                        <th>date_creation</th>
                        <th>Message</th>
                        
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {data.data.map((message:Messages) => (

                        <tr key={message.id}>
                            <td>
                                {message.date_creation}
                            </td>                             
                            <td>{parse(message.message)}</td>
                           
                            <td>
                                
                                <NavLink to={`/message/${message.id.toString()}`}>
                                    <span className="visually-hidden">{translate('btn_voir')}</span>
                                    <i className="bi bi-eye-fill"></i>
                                </NavLink>
                            </td>
                            
                        </tr>

                    ))}

                </tbody>
                </table>
                <Pager curpage={data.page} totalpages={data.pages} setter={setPage}></Pager>
                
                </>
            ):null
        );
}
export default MessagesList;